import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DashboardService} from '../../../../services/dashboard.service';
import {AlertService} from 'ngx-alerts';
import {ChartType} from '../../../dashboard/dashboard.model';
import {ApexChart} from 'ng-apexcharts';

@Component({
  selector: 'app-driving-alerts-analysis',
  templateUrl: './driving-alerts-analysis.component.html',
  styleUrls: ['./driving-alerts-analysis.component.scss']
})
export class DrivingAlertsAnalysisComponent implements OnInit {
  customerName: string = '';
  customerId: any;
  title: any = 'Driving Alerts Analysis Report of: ';
  riskAnalysisDateRange: FormGroup = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });
  search: any = {
    periodFrom: undefined,
    periodTo: undefined
  };

  alertsDataResponse: any[] = [];
  alertsAnalysisData: any;

  chartOptions: any;

  constructor(private router: Router, private route: ActivatedRoute, private datePipe: DatePipe,
              private dashboardService: DashboardService, private alertService: AlertService) {

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (res: any) => {
        this.customerName = res['customerName'];
        this.title += this.customerName;
      }
    );
    this.customerId = this.route.snapshot.params.id;
    this.getDrivingAlertsAnalysis();
  }

  onDateRangeChange() {
    if (this.riskAnalysisDateRange.value.start && this.riskAnalysisDateRange.value.end) {
      this.search.periodFrom = (this.datePipe.transform(new Date(this.riskAnalysisDateRange.value.start), 'yyyy-MM-dd'));
      this.search.periodTo = (this.datePipe.transform(new Date(this.riskAnalysisDateRange.value.end), 'yyyy-MM-dd'));
      this.getDrivingAlertsAnalysis();
    }
  }

  onClearDateRangeClick() {
    this.riskAnalysisDateRange.get('start').setValue(undefined);
    this.riskAnalysisDateRange.get('end').setValue(undefined);
    this.search.periodFrom = undefined;
    this.search.periodTo = undefined;
    this.getDrivingAlertsAnalysis();
  }


  private getDrivingAlertsAnalysis() {
    this.dashboardService.getDrivingAlertsAnalysis(this.customerId, this.search).subscribe(
      (res: any) => {
        this.alertsDataResponse = res.userDrivingAnalysis;
        this.processChartData(this.alertsDataResponse);
      }, error => {
        console.error(error);
        this.alertService.danger(error.message ? error.message : error);
      }
    );
  }

  private processChartData(alertsDataResponse: any[]) {

    let overSpeed: any;
    let harshBreaking: any;
    let harshAcceleration: any;
    let highRpm: any;
    let data1: any[] = [];
    let data2: any[] = [];
    if (alertsDataResponse && alertsDataResponse.length) {
      alertsDataResponse.forEach(da => {
        data1.push(da.alertsCount);
        data2.push(da.maxAlertValue?Number(da.maxAlertValue).toFixed(2):0);
        
        // if (da.alertName.toLowerCase() == 'overspeed') {
        //   data1.push(da.alertsCount);
        //   data2.push(da.maxAlertValue?Number(da.maxAlertValue).toFixed(2):0);
        //   // overSpeed = {name: '', data: [da.alertsCount, da.maxAlertValue]};
        // }
        // if (da.alertName.toLowerCase() == 'harsh accelaration' || da.alertName.toLowerCase() == 'harsh acceleration') {
        //   data1.push(da.alertsCount);
        //   data2.push(da.maxAlertValue?Number(da.maxAlertValue).toFixed(2):0);
        //   // harshAcceleration = {name: '', data: [da.alertsCount, da.maxAlertValue]};
        // }
        // if (da.alertName.toLowerCase() == 'harsh braking') {
        //   data1.push(da.alertsCount);
        //   data2.push(da.maxAlertValue?Number(da.maxAlertValue).toFixed(2):0);
        //   // harshBreaking = {name: '', data: [da.alertsCount, da.maxAlertValue]};
        // }
        // if (da.alertName.toLowerCase() == 'high rpm') {
        //   data1.push(da.alertsCount);
        //   data2.push(da.maxAlertValue?Number(da.maxAlertValue).toFixed(2):0);
        //   // highRpm = {name: '', data: [da.alertsCount, da.maxAlertValue]};
        // }
      });
    }
    // this.alertsAnalysisData = {
    //   series: [{name: 'Count', data: data1}, {name: 'Max Value', data: data2},],
    //   chart: {
    //     height: 280,
    //     type: 'bar',
    //   },
    //   labels: ['OVER SPEED', 'HARSH ACCELERATION', 'HARSH BREAKING', 'HIGH RPM'],
    //   plotOptions: {
    //     bar: {
    //       borderRadius: 1,
    //       barHeight: '20%',
    //       // distributed: true
    //     }
    //   },
    //   dataLabels: {
    //     enabled: false,
    //     offsetX: -6,
    //     // style: {
    //     //   colors: ['#1cbb8c', '#ff8c00']
    //     // }
    //   },
    //   legend: {
    //     show: false,
    //   },
    //   // colors: ['#1cbb8c', '#ff8c00'],
    // };


    this.chartOptions = {
      series: [
        {
          name: 'Count',
          type: 'column',
          data: data1
        },
        {
          name: 'Max G-Force',
          type: 'line',
          data: data2
        }
      ],
      chart: {
        height: 350,
        type: 'line'
      },
      stroke: {
        width: [0, 4]
      },
      title: {
        text: 'Improvement Plan'
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1]
      },
      labels: alertsDataResponse?.map(da=>da.alertName.toUpperCase()),
      xaxis: {
        type: 'category',
        position: 'bottom',
      },
      yaxis: [
        {
          decimalsInFloat:0,
          title: {
            text: 'Alerts Count'
          }
        },
        {
          decimalsInFloat:4,
          opposite: true,
          title: {
            text: 'Max G-Force Value'
          }
        }
      ]
    };

    // this.alertsAnalysisData = {
    //   labels: ['OVER SPEED', 'HARSH ACCELERATION', 'HARSH BREAKING', 'HIGH RPM'],
    //   datasets: [
    //     {
    //       label: "Total Alerts",
    //       backgroundColor: "pink",
    //       borderColor: "red",
    //       borderWidth: 1,
    //       data: data1
    //     },
    //     {
    //       label: "Max G-Force Value",
    //       backgroundColor: "lightblue",
    //       borderColor: "blue",
    //       borderWidth: 1,
    //       data: data2
    //     }
    //   ],
    //   options: {
    //     maintainAspectRatio: false,
    //     scales: {
    //       xAxes: [
    //         {
    //           gridLines: {
    //             color: 'rgba(166, 176, 207, 0.1)'
    //           },
    //         }
    //       ],
    //       yAxes: [
    //         {
    //           gridLines: {
    //             color: 'rgba(166, 176, 207, 0.1)'
    //           }, ticks: {
    //
    //           }
    //         }
    //       ]
    //     }
    //   }
    // };

  }

}
